/**
 * Where «پیگیری درخواست برداشت» goes: to the request itself when there is
 * one, and to the list of them when there are several.
 *
 * It used to open one request whatever the count, so a member with two open
 * requests tapped «پیگیری درخواست‌های برداشت (۲)» and got the detail of just
 * one of them, with no way to the other from there.
 */
export const withdrawalTrackingPath = (withOpenRequest: Array<IDepositFund>) =>
    withOpenRequest.length === 1 && withOpenRequest[0].open_request
        ? `/fund/withdraw-request/detail/${withOpenRequest[0].open_request.id}?fund=${withOpenRequest[0].moneypool_id}`
        : '/fund/withdraw-request/list'
